export const DEFAULT_IMAGE_WIDTH = 230
export const DEFAULT_IMAGE_HEIGHT = 160
